import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20orange%20and%20golden%20lines%2C%20minimalist%20modern%20design%2C%20soft%20glowing%20light%20effects%2C%20digitally%20inspired%20pattern%2C%20luxurious%20cinematic%20atmosphere%2C%20no%20text%20or%20icons&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-primary-600/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          开始你的观影之旅
        </h2>
        <p className="text-white/80 mb-8 md:mb-10 text-sm md:text-base leading-relaxed">
          50万+优质国产视频等你发现，免费畅享高清画质，多端同步观影体验
        </p>
        <Link
          to="/category/yingshiju"
          className="inline-flex items-center px-8 py-3.5 bg-white hover:bg-white/90 text-primary-600 font-semibold rounded-full text-sm md:text-base transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-play-circle-fill mr-2 text-lg"></i>立即免费观看
        </Link>
      </div>
    </section>
  );
}